/** @jsxImportSource @emotion/react */

import { COLORS } from '@btime/constants'
import { css } from '@emotion/react'
import { identity } from 'ramda'
import React from 'react'

import { SmallText } from '../presentation/Text'
import { useNavigation } from '../../utils/contexts/NavigationContext'
import FlexGrid, { FlexCol } from '../structure/FlexGrid'
import Icon from '../../packages/kiti/components/shapes/Icon'

export const MenuItem = ({
  label,
  value,
  children,
  onClick,
  disabled,
  color,
  icon,
  iconLeft,
  iconRight,
  focus,
  t,
  to,
  justify,
  withLine,
  rightContent,
  ...props
}) => {
  const style = css`
    margin: 0;
    ${disabled ? 'opacity: 0.3;' : ''}
    ${withLine ? `border-bottom: solid 1px ${COLORS.light2};` : ''}

		${focus ? `background: ${COLORS.light1};` : ''}

		&:hover {
      background: ${COLORS.light1};
    }

    & > .menuItemLink {
      text-decoration: none;
      padding: 0.8rem 0.5rem;
      display: block;
    }
  `
  const navigate = useNavigation()

  let handleClick = e => {
    e.preventDefault()
    if (disabled) return
    onClick ? onClick() : navigate(to)
  }

  t = t || identity
  iconLeft = iconLeft || icon

  return (
    <li className="menuItem" css={style}>
      <a className="menuItemLink" onClick={handleClick} href={to}>
        <FlexGrid justify={justify || 'flex-start'} gutter={0.3}>
          {iconLeft && <Icon name={iconLeft} color={color || COLORS.dark3} size="1rem" />}
          <SmallText color={color || COLORS.dark3} bold {...props}>
            {t(label || value || children)}
          </SmallText>
          <FlexCol flex={1} />
          {rightContent}
          {iconRight && <Icon name={iconRight} color={color || COLORS.dark3} size="1rem" />}
        </FlexGrid>
      </a>
    </li>
  )
}

const Menu = ({ children }) => {
  const style = css`
    list-style-type: none;
    margin: 0;
    padding: 0;
  `

  return (
    <ul css={style} className="menu">
      {children}
    </ul>
  )
}

export default Menu
